import React, { useEffect, useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Stack,
  Button,
  TextField,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

import api from "../../../../base/services/ResApi"
import Alerts from "../../../../base/errorHandeling/Alerts"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"
import { RequestErrorHandeling } from "../../../../base/errorHandeling/RequestErrorHandeling"

const UpdateTmnlStatusModal = ({
  open,
  onClose,
  terminalSerial,
  setIsStatusChange,
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [trmnlStatus, setTrmnlStatus] = useState("")
  const [isBtnLoading, setIsBtnLoading] = useState(false)

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])
  //success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessage, setSuccessMessage] = useState([])

  //clear all alerts after a timeout
  useEffect(() => {
    if ((iserror || isSuccess) === true) {
      let timerId = setTimeout(() => {
        setIserror(false)
        setErrorMessages([])
        setIsSuccess(false)
        setSuccessMessage([])
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror, isSuccess])

  const handleStatusChange = (e) => {
    setTrmnlStatus(e.target.value)
  }

  const handleUpdate = (e) => {
    e.preventDefault()
    setIsBtnLoading(true)

    const payload = {
      terminalSn: terminalSerial,
      status: trmnlStatus,
    }
    api
      .patch("/terminals/status", payload)
      .then((res) => {
        setIsBtnLoading(false)
        setErrorMessages([])
        setIserror(false)
        setIsSuccess(true)
        setSuccessMessage([res.data?.description])
        setIsStatusChange(true)
      })
      .catch((error) => {
        setIsBtnLoading(false)
        setIsSuccess(false)

        RequestErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow
        )
      })
  }

  const handleClose = () => {
    setTrmnlStatus("")
    onClose()
  }

  return (
    <Dialog
      fullWidth
      open={open}
      PaperProps={{
        style: {
          borderRadius: "10px",
          width: windowWidth >= 1500 ? "1500px" : "1320px",
          margin: 0,
        },
      }}
    >
      <DialogTitle sx={{ backgroundColor: "#116c6f", color: "#fff" }}>
        Update Terminal Status
      </DialogTitle>
      <IconButton
        aria-label="close"
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: "#fff",
        })}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>
      <form onSubmit={handleUpdate}>
        <DialogContent dividers>
          <div>
            <Alerts
              iserror={iserror}
              errorMessages={errorMessages}
              iserrorShow={iserrorShow}
              isSuccess={isSuccess}
              successMessages={successMessage}
            />
          </div>
          <Stack direction="row" spacing={3}>
            <TextField
              name="terminalSerial"
              value={terminalSerial}
              type="text"
              variant="outlined"
              color="secondary"
              label="Terminal Serial"
              disabled
            />
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                value={trmnlStatus}
                label="App Label"
                onChange={handleStatusChange}
              >
                <MenuItem value="ACTIVE">Active</MenuItem>
                <MenuItem value="LOCK">LOCK</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={handleClose} variant="outlined" color="error">
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            color="success"
            loading={isBtnLoading}
            variant="contained"
            loadingPosition="start"
            startIcon={<SaveIcon />}
          >
            Update
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default UpdateTmnlStatusModal
